import React from 'react';

// Slim results loading bar shared by Flights & Hotels. Determinate (driven by real progress),
// with a floor so it always looks alive, a subtle pulse while running, and a completed state.
export const SearchProgress = ({ active, value = 0, label, testid = 'search-progress' }) => {
  if (!active) return null;
  const pct = Math.min(100, Math.max(6, Math.round(value)));
  const done = pct >= 100;
  return (
    <div className="w-full mb-3" data-testid={testid}>
      <div className="h-1.5 w-full rounded-full bg-secondary overflow-hidden">
        <div
          className={`h-full rounded-full bg-accent transition-[width] duration-500 ease-out ${done ? '' : 'animate-pulse'}`}
          style={{ width: `${pct}%` }}
          data-testid={`${testid}-bar`}
        />
      </div>
      {label && <p className="mt-1.5 text-xs text-muted-foreground" data-testid={`${testid}-label`}>{label}</p>}
    </div>
  );
};
